import React, { useEffect, useState } from "react";
import SelectInputs from "./SelectInputs";
import { Chip } from "@mui/material";

const CountryLocation = ({
  itemType,
  locationOption,
  displayLocation,
  setDisplayLocation,
}) => {
  const [locations, setLocations] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    setLocations(locationOption);
  }, [locationOption]);

  useEffect(() => {
    setSelectedIds(displayLocation || []);
    setSelectAll(
      displayLocation.length > 0 &&
        displayLocation.length === locationOption.length
    );
  }, [displayLocation, locationOption]);

  const handleSelectAll = () => {
    if (!selectAll) {
      setSelectedIds(locations.map((item) => item.id));
      setDisplayLocation(locations.map((item) => item.id));
    } else {
      setSelectedIds([]);
      setDisplayLocation([]);
    }
    setSelectAll(!selectAll);
  };

  const handleDelete = (id) => {
    const value = selectedIds.filter((item) => item !== id);
    setSelectedIds(value);
    setDisplayLocation(value);
  };

  return (
    <div className={`col-lg-12 col-md-12 col-sm-12 col-12 row`}>
      <div className={`col-md-12 col-sm-12 col-12`}>
        <div className="fieldrow">
          <label className="f_label">
            {itemType?.key === "country" ? itemType.title : "Display Location"}
            {itemType?.required && <span style={{ color: "red" }}>*</span>}
          </label>

          <SelectInputs
            locationType="DisplayLocation"
            selectedValue={selectedIds}
            options={locations}
            setSelectedValue={(e) => {
              setSelectedIds(e);
              setDisplayLocation(e);
            }}
            style={{ width: "100%", height: "45px" }}
          />
          {/* Select All */}
          <div className="iti_inner">
            <div className="icheck-primary d-inline">
              <input
                type="checkbox"
                id="dynamicSelectAll"
                checked={selectAll}
                onChange={handleSelectAll}
              />
              <label htmlFor="dynamicSelectAll">
                {selectAll ? (
                  <p>
                    <span style={{ fontWeight: 600 }}>Remove All</span>
                  </p>
                ) : (
                  <p>
                    <span style={{ fontWeight: 200 }}>Select All</span>
                  </p>
                )}
              </label>
            </div>
          </div>

          {selectedIds?.length > 0 && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "5px",

                maxHeight: "100px",
                border: "1px solid black",
                padding: "10px",
                overflowY: "scroll",
                borderRadius: "6px",
              }}
            >
              {selectedIds?.map((data, index) => (
                <Chip
                  onDelete={() => handleDelete(data)}
                  key={index + ""}
                  size="small"
                  sx={{
                    borderRadius: "100px",
                  }}
                  label={
                    locations.find((item) => item.id === data)?.location_name
                  }
                ></Chip>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CountryLocation;
